import React, { Component } from 'react';

import { Headline, Copy } from '../../theme';
import { Economisesc as EcoSvg } from '../../svg';
import { isMobile } from '../../util';

class Economisesc extends Component {

    render() {
        return (
            <div id="Economisesc" className="container__fluid">
                <div className="w__flex w__flex-column Justify-center">

                    <div className="w__flex w__flex-row Align-center">
                        <div className="cell">

                            <div className="tree">
                                <EcoSvg.Tree />
                            </div>

                            <div className="whale">
                                <EcoSvg.Whale />
                            </div>

                            <Headline large alignLeft padding="15vw" >
                                <p style={{ color: '#181818' }}>Economisesc,</p>
                                <p
                                    style={{ color: '#181818' }}
                                    ref={this.getPosRelToThis}
                                >
                                    Dar cum?

                                    {
                                        !isMobile && (
                                            <span
                                                className="guy"
                                            >
                                                <EcoSvg.Guy />
                                            </span>
                                        )
                                    }
                                </p>

                            </Headline>


                            <div className="mobile__hidden">
                                <Copy normal alignLeft padding="15vw">
                                    Economiseste energie si bani, schimband
                                </Copy>
                                <Copy normal alignLeft padding="15vw">
                                    obiceiuri sau electrocasnice vechi.
                                </Copy>
                            </div>

                            <div className="mobile__visible">
                                <Copy normal alignLeft padding="15vw">
                                    Economiseste energie si bani,
                                </Copy>
                                <Copy normal alignLeft padding="15vw">
                                    schimband obiceiuri sau
                                </Copy>
                                <Copy normal alignLeft padding="15vw">
                                    electrocasnice vechi.
                                </Copy>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Economisesc;


// WEBPACK FOOTER //
// ./src/components/pages/Economisesc/Economisesc.jsx